<template>
  <div class="Inbound">
    <div class="page-title">{{ $t("lang.title_inbound") }}</div>
    <ATable
      ref="table"
      max-height="720px"
      class="no-pointer"
      :placeholder="placeholder"
      :data="items_inbound"
      :loading="loading_inbound"
      :search_field="search_field"
      hide-button-insert
      hide-pagination
      border
    >
      <div slot="search">
        <div class="inline">
          <APeriodSelector
            ref="period"
            :value="search_period"
            hide-select
            @change="handleChangePeriod"
          />
        </div>
        <div class="inline">
          <el-button
            type="primary"
            size="mini"
            round
            v-shortkey="['f5']"
            @shortkey.native="handleClickSearch"
            @click="handleClickSearch"
            >{{ $t("button.search") }}(F5)</el-button
          >
        </div>
      </div>
      <el-table-column
        type="index"
        :label="$t('lang.No')"
        :width="$width.index"
        :index="handleIndex"
      />
      <el-table-column
        prop="code"
        width="90"
        :label="$t('lang.purchase_number')"
      />
      <el-table-column
        prop="prodct_type_name"
        width="100"
        :label="$t('lang.material_classification')"
      />
      <el-table-column
        prop="product_name"
        :label="$t('lang.material_name')"
        show-overflow-tooltip
      />
      <el-table-column prop="customer_name" width="200" label="거래처">
      </el-table-column>
      <el-table-column
        prop="unit_type_name"
        width="50"
        :label="$t('lang.unit')"
      ></el-table-column>
      <el-table-column
        prop="inbound"
        class-name="cell-number"
        width="80"
        :label="$t('lang.warehousing_quantity')"
      />
      <el-table-column
        prop="deal_date"
        class-name="cell-number"
        width="80"
        label="입고일"
      />
      <el-table-column label="품번출력" width="80">
        <template slot-scope="scope">
          <div v-if="resolveSerialPrint(scope.row)" class="align-center">
            <el-button size="tiny" @click="handleClickPrintSerial(scope.row)"
              >출력</el-button
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="current"
        class-name="cell-number"
        width="80"
        :label="$t('lang.current_inventory')"
        :formatter="resolveCurrent"
      />
    </ATable>
    <el-dialog
      custom-class="form-dialog"
      top="0"
      width="800px"
      :title="$t('title.serial_print')"
      :visible.sync="dialog_visible"
      :close-on-click-modal="false"
      append-to-body
      destroyOnClose
    >
      <SerialPrint
        ref="print"
        v-if="dialog_visible"
        :data="selected_data"
        @completed="handleCompletePrint"
      />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SerialPrint from "./SerialPrint";

export default {
  name: "Inbound",
  components: { SerialPrint },
  data() {
    return {
      items_inbound: [],
      placeholder: "발주번호, 품목, 거래처",
      search_field: ["code", "product_name", "customer_name"],
      search_period: { value: "1w" },
      loading_inbound: false,
      period: {},
      dialog_visible: false,
      selected_data: undefined,
    };
  },
  mounted() {
    this.$nextTick(() => this.loadData());
  },
  computed: {
    ...mapGetters(["table_customer", "table_product"]),
  },
  methods: {
    loadData() {
      this.loading_inbound = true;
      this.api.listInboundStock(this.period).then((res) => {
        this.loading_inbound = false;
        if (res.error !== this.system.noError) {
          this.util.notify_error(this, "inbound", res.message);
          return;
        }
        const result = [];
        for (let i = 0; i < res.data.length; i++) {
          const data = res.data[i];
          data.customer_name = this.table_customer.find(
            (c) => c.id === data.customer_id
          ).name;
          result.push(data);
        }
        this.items_inbound = result;
      });
    },
    resolveCurrent(row, column, value) {
      return row.unit_multiply ? value / row.unit_multiply : value;
    },
    resolveSerialPrint(data) {
      let product = this.table_product.find((p) => p.id === data.product_id);
      if (!product) {
        return false;
      }
      return product.kind === "SERIAL";
    },
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) {
        return;
      }
      this.loadData();
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleClickPrintSerial(data) {
      this.selected_data = data;
      this.dialog_visible = true;
    },
    handleCompletePrint() {
      this.dialog_visible = false;
    },
  },
};
</script>
